import { noSignAction, signActionTime } from "../utils/http";
import tools from "../utils/fun";
import httpConfig from "../baseConfig/httpConfig";
import dataConfig from "../baseConfig/dataConfig";
import { refresh } from "less";

let PaymenetManager = {};

/**
 * 创建提现订单
 * @param {*} self 
 * @param {*} upi 
 * @param {*} amount 
 * @param {*} callback 
 * @param {*} errCallback 
 */
PaymenetManager.withdraw = function (self, upi, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/easebuzz/withdraw";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform,
        upi: upi,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 60000);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}
PaymenetManager.withdrawH5 = function (self, bankName, bankCardNo, bankCardHolder, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/india/h5/withdraw";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform,
        bankName: bankName,
        bankCardNo: bankCardNo,
        bankCardHolder: bankCardHolder,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 60000);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

PaymenetManager.withdrawH5UPI = function (self, upi, bankCardHolder, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/india/h5/withdraw";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform,
        upi: upi,
        bankCardHolder: bankCardHolder,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 60000);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

PaymenetManager.withdrawChecker = function (self, reference, callback, errCallback) {
    let urlStr = "reference=" + reference;
    let url = httpConfig.baseUrl() + "/api/payments/easebuzz/query/order?" + urlStr;
    let httpHandler = signActionTime(self, "POST", url, "", { urlStr: urlStr }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback();
            } else {
                errCallback("err." + res.result);
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

/**
 * 创建充值订单
 * @param {*} self 
 * @param {*} amount 
 * @param {*} callback 
 * @param {*} errCallback 
 */

PaymenetManager.deposite = function (self, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/easebuzz/create/order";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {



                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}
///api/payments/india/h5/create/order
PaymenetManager.depositeH5 = function (self, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/india/h5/create/order";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

/**
 * 第三个充值方式
 * @param {*} self 
 * @param {*} amount 
 * @param {*} callback 
 * @param {*} errCallback 
 */
PaymenetManager.depositeEP = function (self, amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/ezpay/create/order";
    let platform = tools.getPlatForm();
    let login = tools.getLoginToken(self);
    if (!login.isLogin) {
        return;
    }
    let callbackUri = tools.getSiteResourceRoot() + '/#/deposit?ver=' + httpConfig.version;
    let param = {
        platform: platform,
        amount: amount,
        redirectUrl:callbackUri,
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}


PaymenetManager.withdrawEP = function (self, cardInfo,  amount, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/ezpay/withdraw";
    let platform = tools.getPlatForm();
    !cardInfo.payeeAddress && (cardInfo.payeeAddress = '2031,AddrStreet Panchratna, M Parmanand Marg, Opera House,Mumbai');
    let param = {
        platform: platform,
        bankCode: cardInfo.bankCode,
        accountNumber: cardInfo.bankCardNo,
        accountHolderName: cardInfo.bankCardHolder,
        payeeEmail: cardInfo.payeeEmail,
        payeeAddress: cardInfo.payeeAddress,
        amount: amount
    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 60000);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(self.$t("err." + res.result));
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

/**
 * 客户端充值成功通知服务器端
 * @param {*} self 
 * @param {*} params 
 * @param {*} callback 
 * @param {*} errCallback 
 */
PaymenetManager.depositeSuccess = function (self, params, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/easebuzz/successNotify";
    let httpHandler = signActionTime(self, "POST", url, params, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                errCallback(
                    self.$t("err." + res.result)
                );
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}


PaymenetManager.checkWithdrawAmount = function (self, amount, payType, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/payments/checkWithdrawAmount?" + `amount=${amount}&payType=${payType}`
    let param = {
        amount: amount,
        payType: payType,

    };
    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: `amount=${amount}&payType=${payType}` }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1 || res.result == 0) {
                callback(res.data);
            } else {
                errCallback(
                    self.$t("err." + res.result)
                );
            }
        }).catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}
PaymenetManager.withdrawType = function (self, callback, errCallback) {
    let params = {

    };
    let url = httpConfig.baseUrl() + "/api/payments/india/h5/withdraw/type";
    let httpHandler = signActionTime(self, "POST", url, params, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
                self.$store.commit("temp/setPayType", res.data);
            } else {
                errCallback(
                    self.$t("err." + res.result)
                );
            }
        }).catch(error => {
            errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}
export default PaymenetManager;



// WEBPACK FOOTER //
// ./src/interface/payment.js